import { render } from "./SeriesPage.vue?vue&type=template&id=682a7dca&scoped=true"
import script from "./SeriesPage.vue?vue&type=script&lang=js"
export * from "./SeriesPage.vue?vue&type=script&lang=js"

import "./SeriesPage.vue?vue&type=style&index=0&id=682a7dca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682a7dca"]])

export default __exports__